import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from "react";
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import BotaoNovoCadastro from '../../components/botao/BotaoNovoCadastro'
import Footer from '../../components/footer/Footer'
import ModalEditarCadastro from '../../components/modal/ModalEditarCadastro';
import { TbPencil } from "react-icons/tb";
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { StyleContext } from '../../context/StyleContext';
import Tabela from '../../components/Tabela';


function SetorGerenciaDemanda() {
    const { SetoresConsulta, modalEditarOpen, loading, ListaSetorGerenciaConsulta, setModalEditar, setDemandaAtual, Success, Error, Permissao, ListaFiltroSetorGerencia, totalRegistrosSetorGerencia, filtroSetorGerencia, totalRegistrosFiltroSetorGerencia, AtualizarStatus } = useContext(ApiContext)
    const { h3Demanda, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditCadastro = (props) => {
        setDemandaAtual(props)
        setModalEditar(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroSetorGerencia(searchTerm, currentPage, pageSize);
        } else {
            ListaSetorGerenciaConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroSetorGerencia : totalRegistrosSetorGerencia;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <>
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <Header pagina={'Cadastros'} subpagina={'Setor gerência'}></Header>
            <MenuLateral></MenuLateral>
            <div className="container-principal">
                <div className="demanda-header">
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <BotaoNovoCadastro end="SetorGerenciaDemanda" currentPage={currentPage} />
                    }
                    {modalEditarOpen &&
                        <ModalEditarCadastro end="SetorGerenciaDemanda" currentPage={currentPage} />
                    }
                </div>
                <div className="card card-table">
                    <h3 className='h3-demanda' style={h3Demanda}>Setor Gerência da Demanda</h3>
                    <div className="table-responsive text-nowrap">
                        {loading ? (
                            <div className="loading-screen">
                                <div className="loader-container">
                                    <div className="spinner"></div>
                                </div>
                            </div>
                        ) : (
                            <div className='tabela-geral'>
                                <Tabela
                                    data={searchTerm.trim() !== "" ? filtroSetorGerencia : SetoresConsulta}
                                    columns={[
                                        { label: "Setor gerência", field: "descricao", width: "40%", render: (x) => x?.descricao || "-" },
                                        {
                                            label: "Ativo",
                                            width: "10%",
                                            align: "center",
                                            render: (x) => (
                                                <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                    <input type='checkbox' checked={x.ativo} className="toggleBtn" onChange={() => AtualizarStatus("SetorGerenciaDemanda", x.key, !x.ativo, currentPage)} />
                                                </div>
                                            ),
                                        },
                                        {
                                            label: "Opções",
                                            width: "10%",
                                            align: "center",
                                            render: (x) => (
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    <button onClick={() => EditCadastro(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                        <TbPencil />
                                                    </button>
                                                </div>
                                            ),
                                        },
                                    ]}
                                    loading={loading}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    setCurrentPage={setCurrentPage}
                                    searchTerm={searchTerm}
                                    setSearchTerm={setSearchTerm}
                                    onSearch={(term) => {
                                        setCurrentPage(1);
                                        if (term.trim() !== "") {
                                            ListaFiltroSetorGerencia(term, 1, 10);
                                        } else {
                                            ListaSetorGerenciaConsulta(1, 10);
                                        }
                                    }}
                                    corTerciaria={corTerciaria}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </>
    );
}

export default SetorGerenciaDemanda;